// @flow

import CoveragePage from 'esm-web-pro/containers/pages/coverage/CoveragePage';
import React from 'react';
import { Route } from 'react-router';


const CoverageMap = (
    <Route path="/coverage/:mapIdentity?/:versionType?" component={CoveragePage} />
);

export default CoverageMap;
